export default "__VITE_ASSET__B1gdP7Fi__"